module.exports = __webpack_public_path__ + "media/flowplayer_v7/skin/icons/flowplayer-48bc6ec694aace85b7cf05d246801c00.svg";